module.exports = __webpack_public_path__ + "static/media/flighdelayEmergency.cb8e968e.svg";